import Certificados from '../components/certificados'
import Proposito from '../components/proposito'
import QuemSomosHome from '../components/quem-somos'
import Rodape from '../components/rodape'
import Transformacoes from '../components/transformacoes'
import Valores from '../components/valores'
import Verticais from '../components/verticais'
import Video from '../components/video'
import VisaoMissao from '../components/visaoMissao'

export default function QuemSomos() {
  return (
    <div>
      <QuemSomosHome />
      <Proposito />
      <Video />
      <Verticais />
      <Transformacoes />
      <VisaoMissao />
      <Valores />
      <Certificados
        text={
          <span className="text-4xl lg:text-5xl">
            Certificações que conquistamos
          </span>
        }
      />
      <Rodape />
    </div>
  )
}
